import { Routes } from "@angular/router";
import { MainLayoutComponent } from "./layouts/main-layout/main-layout.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { CheckoutLayoutComponent } from "./layouts/checkout-layout/checkout-layout.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      {
        path: "home",
        loadChildren: () =>
          import("./components/home/home.module").then((m) => m.HomeModule),
      },
      {
        path: "store",
        loadChildren: () =>
          import("./components/store/store.module").then((m) => m.StoreModule),
      },
      /*       {
        path: 'team',
        loadChildren: './components/team/team.module#TeamModule',
      }, */
      {
        path: "contact",
        loadChildren: () =>
          import("./components/contact/contact.module").then(
            (m) => m.ContactModule
          ),
      },
      {
        path: "about",
        loadChildren: () =>
          import("./components/about/about.module").then((m) => m.AboutModule),
      },
      {
        path: "custom",
        loadChildren: () =>
          import("./components/custom/custom.module").then(
            (m) => m.CustomModule
          ),
      },
      {
        path: "shopping",
        loadChildren: () =>
          import("./components/shopping/shopping.module").then(
            (m) => m.ShoppingModule
          ),
      },
      {
        path: "categories/:id",
        loadChildren: () =>
          import("./components/articles/category/category.module").then(
            (m) => m.CategoryModule
          ),
      },
      {
        path: "article/:id",
        loadChildren: () =>
          import(
            "./components/articles/article-detail/article-detail.module"
          ).then((m) => m.ArticleDetailModule),
      },
      {
        path: "outlet",
        loadChildren: () =>
          import("./components/outlet/outlet.module").then(
            (m) => m.OutletModule
          ),
      },
    ],
  },
  {
    path: "checkout",
    component: CheckoutLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./components/checkout/checkout.module").then(
            (m) => m.CheckoutModule
          ),
      },
    ],
  },
  { path: "**", component: NotFoundComponent },
];
